import { render, staticRenderFns } from "./ReviewListItem.vue?vue&type=template&id=37378965&scoped=true&"
import script from "./ReviewListItem.vue?vue&type=script&lang=js&"
export * from "./ReviewListItem.vue?vue&type=script&lang=js&"
import style0 from "./ReviewListItem.vue?vue&type=style&index=0&id=37378965&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37378965",
  null
  
)

export default component.exports